/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: none;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
  height: 100%;
  margin: calc(18rem /14) 0 0 0;
}

:host([selected]) {
  display: flex;
}

:host([hidden]) {
  display: none;
}

.stretch {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}`;
export { style };
